import type { Theme } from '@mui/material';

export const styles = {
  goldenPill: (theme: Theme) => ({
    color: theme.colors.secondary[800],
    backgroundColor: theme.colors.secondary[300],
    fontWeight: 600,
  }),
};
